import { getExternalCalendarEventQueryConfig } from '@griply/hooks';
import { CalendarEventDetails, CalendarEventRef } from '@griply/types';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getExternalCalendarEvent } from 'shared/services/backend-api';

// Shares the popup's cache entry, so acting on an event that was just open costs no second call.
export const useFetchExternalCalendarEvent = () => {
  const client = useQueryClient();

  return useCallback(
    (eventRef: CalendarEventRef): Promise<CalendarEventDetails | null> =>
      client.fetchQuery(
        getExternalCalendarEventQueryConfig(eventRef, getExternalCalendarEvent),
      ),
    [client],
  );
};
